(() => {
  const root = document.querySelector('[data-gallery-landing-filters]');
  const grid = document.querySelector('.gallery-landing-grid #ProductGridContainer');
  if (!root || !grid) return;

  const heading = document.querySelector('.gallery-landing-grid .gallery-works-heading');
  const shortcuts = [...document.querySelectorAll('.gallery-discovery--shortcuts-only .gallery-discovery__shortcuts a[data-gallery-view]')];
  const locale = document.documentElement.lang.toLowerCase();
  const language = locale.startsWith('zh') ? 'zh' : locale.startsWith('de') ? 'de' : locale.startsWith('en') ? 'en' : 'fr';
  const messages = {
    fr: { works: 'œuvres à découvrir', books: 'livres à découvrir', artist: 'Artiste', availability: 'Statut de vente', type: 'Type', style: 'Style', size: 'Taille', colors: 'Couleurs', color: 'Couleur', selectedColors: 'Couleurs sélectionnées', colorHint: 'Une ou plusieurs couleurs · Recliquez pour retirer', remove: 'Retirer', sort: 'Trier par', clear: 'Effacer les filtres', retry: 'Réessayer les filtres', date: 'Date', price: 'Prix', upTo: 'jusqu’à', to: 'à', over: 'plus de', colorNames: {} },
    en: { works: 'artworks to discover', books: 'books to discover', artist: 'Artist', availability: 'Sales status', type: 'Type', style: 'Style', size: 'Size', colors: 'Colors', color: 'Color', selectedColors: 'Selected colors', colorHint: 'Choose one or more colors · Click again to remove', remove: 'Remove', sort: 'Sort by', clear: 'Clear filters', retry: 'Retry filters', date: 'Date', price: 'Price', upTo: 'up to', to: 'to', over: 'over', colorNames: { Blanc: 'White', Noir: 'Black', Gris: 'Gray', 'Beige / Brun': 'Beige / Brown', Rouge: 'Red', Orange: 'Orange', Jaune: 'Yellow', Vert: 'Green', Bleu: 'Blue', Violet: 'Purple', Rose: 'Pink' } },
    de: { works: 'Kunstwerke entdecken', books: 'Bücher entdecken', artist: 'Künstler', availability: 'Verkaufsstatus', type: 'Art', style: 'Stil', size: 'Größe', colors: 'Farben', color: 'Farbe', selectedColors: 'Ausgewählte Farben', colorHint: 'Eine oder mehrere Farben · Erneut klicken zum Entfernen', remove: 'Entfernen', sort: 'Sortieren nach', clear: 'Filter zurücksetzen', retry: 'Filter erneut laden', date: 'Datum', price: 'Preis', upTo: 'bis', to: 'bis', over: 'über', colorNames: { Blanc: 'Weiß', Noir: 'Schwarz', Gris: 'Grau', 'Beige / Brun': 'Beige / Braun', Rouge: 'Rot', Orange: 'Orange', Jaune: 'Gelb', Vert: 'Grün', Bleu: 'Blau', Violet: 'Violett', Rose: 'Rosa' } },
    zh: { works: '件作品待您探索', books: '本書待您探索', artist: '藝術家', availability: '販售狀態', type: '類型', style: '風格', size: '尺寸', colors: '色彩', color: '顏色', selectedColors: '已選顏色', colorHint: '可選多種顏色 · 再按一次即可取消', remove: '移除', sort: '排序', clear: '清除篩選', retry: '重新載入篩選', date: '日期', price: '價格', upTo: '不超過', to: '至', over: '超過', colorNames: { Blanc: '白色', Noir: '黑色', Gris: '灰色', 'Beige / Brun': '米色／棕色', Rouge: '紅色', Orange: '橙色', Jaune: '黃色', Vert: '綠色', Bleu: '藍色', Violet: '紫色', Rose: '粉紅色' } },
  };
  const t = messages[language];
  const colorName = (value) => t.colorNames[value] || value;
  const optionNames = {
    fr: {},
    en: { Abstrait: 'Abstract', Figuratif: 'Figurative', Expressionnisme: 'Expressionism', Surréaliste: 'Surrealism', 'Art numérique': 'Digital art', 'Art textile': 'Textile art', Dessin: 'Drawing', Estampe: 'Print', Peinture: 'Painting', 'En vente': 'For sale', Vendu: 'Sold', 'Non destiné à la vente': 'Not offered for sale' },
    de: { Abstrait: 'Abstrakt', Figuratif: 'Figürlich', Expressionnisme: 'Expressionismus', Surréaliste: 'Surrealismus', Sculpture: 'Skulptur', 'Art numérique': 'Digitale Kunst', 'Art textile': 'Textilkunst', Collage: 'Collage', Dessin: 'Zeichnung', Estampe: 'Druckgrafik', Peinture: 'Malerei', 'En vente': 'Zum Verkauf', Vendu: 'Verkauft', 'Non destiné à la vente': 'Nicht zum Verkauf' },
    zh: { Abstrait: '抽象', Figuratif: '具象', Expressionnisme: '表現主義', Surréaliste: '超現實主義', Sculpture: '雕塑', 'Art numérique': '數位藝術', 'Art textile': '纖維藝術', Collage: '拼貼', Dessin: '素描', Estampe: '版畫', Peinture: '繪畫', 'En vente': '出售中', Vendu: '已售出', 'Non destiné à la vente': '非供出售' },
  };
  const translateOption = (label) => {
    const match = label.match(/^(.*?)(\s*\(\d+\))?$/);
    const translated = optionNames[language][match[1]] || match[1];
    return translated + (match[2] || '');
  };
  const allCount = Number(heading?.querySelector('span')?.textContent.trim()) || 0;
  const sourcePath = root.dataset.sourceUrl;
  const allowedKey = (key) => key.startsWith('filter.') || key === 'sort_by' || key === 'page';
  const sortLabels = new Map([
    ['created-descending', `${t.date} ↓`],
    ['created-ascending', `${t.date} ↑`],
    ['price-ascending', `${t.price} ↑`],
    ['price-descending', `${t.price} ↓`],
  ]);
  const sizeLabels = new Map([
    ['XS', `XS · ${t.upTo} 20 cm`],
    ['S', `S · 20 ${t.to} 40 cm`],
    ['M', `M · 40 ${t.to} 100 cm`],
    ['L', `L · 100 ${t.to} 200 cm`],
    ['XL', `XL · ${t.over} 200 cm`],
  ]);
  const colorSwatches = new Map([
    ['Blanc', '#ffffff'],
    ['Noir', '#171717'],
    ['Gris', '#898b8d'],
    ['Beige / Brun', '#ad8d71'],
    ['Rouge', '#d94c5c'],
    ['Orange', '#f28b49'],
    ['Jaune', '#e9bd46'],
    ['Vert', '#36a985'],
    ['Bleu', '#3f8fcb'],
    ['Violet', '#8e6bc2'],
    ['Rose', '#e579ab'],
    ['Multicolore', 'conic-gradient(#bc3c3d, #e5c44c, #63916a, #567ab2, #8567a4, #bc3c3d)'],
  ]);
  let pending;

  const viewFromUrl = () => {
    const view = new URLSearchParams(window.location.search).get('gallery_view');
    return shortcuts.some((link) => link.dataset.galleryView === view) ? view : 'all';
  };

  const showView = (view, count = allCount) => {
    root.hidden = view !== 'all';
    for (const link of shortcuts) {
      if (link.dataset.galleryView === view) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    }
    if (!heading) return;
    heading.replaceChildren();
    heading.append(makeElement('span', '', String(count)), ` ${view === 'books' ? t.books : t.works}`);
  };

  const updateViewAddress = (view) => {
    const url = new URL(window.location.href);
    for (const key of [...url.searchParams.keys()]) {
      if (allowedKey(key) || key === 'gallery_view') url.searchParams.delete(key);
    }
    if (view !== 'all') url.searchParams.set('gallery_view', view);
    window.history.pushState({}, '', url);
  };

  const useSourceGrid = (sourceGrid, limit) => {
    grid.classList.remove('gallery-landing-grid__entering');
    grid.innerHTML = sourceGrid.innerHTML;
    const items = [...grid.querySelectorAll('li.grid__item')];
    if (limit) {
      items.slice(limit).forEach((item) => item.remove());
      grid.querySelector('.pagination')?.remove();
    }
    grid.querySelectorAll('.scroll-trigger, .animate--slide-in').forEach((item) => {
      item.classList.remove('scroll-trigger', 'animate--slide-in');
    });
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      void grid.offsetWidth;
      grid.classList.add('gallery-landing-grid__entering');
    }
    return limit ? Math.min(items.length, limit) : items.length;
  };

  async function loadView(view, changeHistory) {
    if (view === 'all') {
      showView('all');
      if (changeHistory) updateViewAddress('all');
      load(new URLSearchParams(), true, false);
      return;
    }
    const shortcut = shortcuts.find((link) => link.dataset.galleryView === view);
    if (!shortcut) return;
    pending?.abort();
    const controller = new AbortController();
    pending = controller;
    root.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(shortcut.href, { credentials: 'same-origin', signal: controller.signal });
      if (!response.ok) throw new Error('Collection unavailable');
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const sourceGrid = page.querySelector('#ProductGridContainer');
      if (!sourceGrid) throw new Error('Collection items unavailable');
      const count = useSourceGrid(sourceGrid, view === 'featured' || view === 'new' ? 8 : 0);
      showView(view, count);
      if (changeHistory) updateViewAddress(view);
    } catch (error) {
      if (error.name === 'AbortError') return;
      window.location.href = shortcut.href;
    } finally {
      if (pending === controller) root.removeAttribute('aria-busy');
    }
  }

  const currentParams = () => {
    const params = new URLSearchParams();
    for (const [key, value] of new URLSearchParams(window.location.search)) {
      if (key === 'sort_by' && !sortLabels.has(value)) continue;
      if (allowedKey(key)) params.append(key, value);
    }
    return params;
  };

  const makeSourceUrl = (params) => {
    const url = new URL(sourcePath, window.location.origin);
    url.search = params.toString();
    return url;
  };

  const makeElement = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text != null) element.textContent = text;
    return element;
  };

  const choose = (params, changeHistory) => {
    params.delete('page');
    load(params, true, changeHistory);
  };

  const fitOpenPanels = () => {
    for (const panel of root.querySelectorAll('.gallery-landing-filters__group[open] > .gallery-landing-filters__options, .gallery-landing-filters__group[open] > .gallery-landing-filters__color-panel')) {
      const available = Math.max(0, window.innerHeight - panel.getBoundingClientRect().top - 16);
      panel.style.setProperty('--gallery-panel-max-height', `${available}px`);
    }
  };

  const renderControls = (source, params) => {
    const openGroupKey = root.querySelector('.gallery-landing-filters__group[open]')?.dataset.galleryFilterKey;
    const bar = makeElement('div', 'gallery-landing-filters__bar');
    const filterOrder = new Map([
      ['artist', 0],
      ['availability', 1],
      ['type', 2],
      ['style', 3],
      ['size', 4],
      ['color', 5],
    ]);
    const hasSalesStatusFilter = [...source.querySelectorAll('#FacetsWrapperDesktop > details input[type="checkbox"]')]
      .some((input) => input.name.includes('custom.gallery_status'));
    const filterKey = (sourceGroup) => {
      const name = sourceGroup.querySelector('input[type="checkbox"]')?.name || '';
      if (name.includes('custom.artiste')) return 'artist';
      if (name.includes('custom.gallery_status')) return 'availability';
      if (name === 'filter.v.availability') return hasSalesStatusFilter ? '' : 'availability';
      if (name.includes('custom.category_of_works')) return 'type';
      if (name.includes('custom.style')) return 'style';
      if (name.includes('custom.gallery_size')) return 'size';
      if (name.includes('custom.gallery_color')) return 'color';
      return '';
    };
    const displayNames = { artist: t.artist, availability: t.availability, type: t.type, style: t.style, size: t.size, color: t.colors };
    const sourceGroups = [...source.querySelectorAll('#FacetsWrapperDesktop > details')].sort((a, b) => {
      return (filterOrder.get(filterKey(a)) ?? 99) - (filterOrder.get(filterKey(b)) ?? 99);
    });
    for (const sourceGroup of sourceGroups) {
      const key = filterKey(sourceGroup);
      if (!key) continue;
      const displayName = displayNames[key];
      const choices = [...sourceGroup.querySelectorAll('input[type="checkbox"]')];
      if (key === 'color') {
        if (!choices.length) continue;
        const colorParamName = choices[0].name;
        const selectedColors = params.getAll(colorParamName);
        const colorGroup = makeElement('details', 'gallery-landing-filters__group gallery-landing-filters__colors');
        colorGroup.dataset.galleryFilterKey = key;
        if (openGroupKey === key) colorGroup.open = true;
        colorGroup.addEventListener('toggle', () => {
          if (!colorGroup.open) return;
          requestAnimationFrame(fitOpenPanels);
          const sortMenu = root.querySelector('.gallery-landing-filters__sort-menu[open]');
          if (sortMenu) sortMenu.open = false;
          for (const other of root.querySelectorAll('.gallery-landing-filters__group[open]')) {
            if (other !== colorGroup) other.open = false;
          }
        });
        colorGroup.append(makeElement('summary', '', selectedColors.length ? `${t.colors} (${selectedColors.length})` : t.colors));
        const panel = makeElement('div', 'gallery-landing-filters__color-panel');
        const hint = makeElement('span', 'gallery-landing-filters__color-hint', t.colorHint);
        const swatches = makeElement('div', 'gallery-landing-filters__swatches');
        swatches.setAttribute('role', 'group');
        swatches.setAttribute('aria-label', t.color);
        for (const choice of choices.sort((a, b) => [...colorSwatches.keys()].indexOf(a.value) - [...colorSwatches.keys()].indexOf(b.value))) {
          if (!colorSwatches.has(choice.value) || choice.value === 'Multicolore') continue;
          const swatch = makeElement('button', 'gallery-landing-filters__swatch', colorName(choice.value));
          if (choice.value === 'Blanc') swatch.classList.add('gallery-landing-filters__swatch--white');
          swatch.type = 'button';
          swatch.title = colorName(choice.value);
          swatch.setAttribute('aria-label', `${t.color} ${colorName(choice.value)}`);
          swatch.setAttribute('aria-pressed', String(selectedColors.includes(choice.value)));
          swatch.style.setProperty('--swatch-color', colorSwatches.get(choice.value));
          swatch.disabled = choice.disabled && !selectedColors.includes(choice.value);
          swatch.addEventListener('click', () => {
            const next = new URLSearchParams(params);
            next.delete(colorParamName);
            for (const value of selectedColors) {
              if (value !== choice.value) next.append(colorParamName, value);
            }
            if (!selectedColors.includes(choice.value)) next.append(colorParamName, choice.value);
            colorGroup.open = false;
            choose(next, true);
          });
          swatches.append(swatch);
        }
        panel.append(hint, swatches);
        colorGroup.append(panel);
        bar.append(colorGroup);
        if (selectedColors.length) {
          const selectedList = makeElement('div', 'gallery-landing-filters__selected-colors');
          selectedList.setAttribute('aria-label', t.selectedColors);
          for (const value of selectedColors) {
            if (!colorSwatches.has(value)) continue;
            const chip = makeElement('button', 'gallery-landing-filters__color-chip');
            if (value === 'Blanc') chip.classList.add('gallery-landing-filters__color-chip--white');
            chip.type = 'button';
            chip.setAttribute('aria-label', `${t.remove} ${colorName(value)}`);
            chip.style.setProperty('--swatch-color', colorSwatches.get(value));
            chip.append(makeElement('span', 'gallery-landing-filters__color-chip-swatch'));
            chip.append(makeElement('span', '', colorName(value)));
            chip.append(makeElement('span', 'gallery-landing-filters__color-chip-remove', '×'));
            chip.addEventListener('click', () => {
              const next = new URLSearchParams(params);
              next.delete(colorParamName);
              for (const selected of selectedColors) {
                if (selected !== value) next.append(colorParamName, selected);
              }
              choose(next, true);
            });
            selectedList.append(chip);
          }
          bar.append(selectedList);
        }
        continue;
      }
      const group = makeElement('details', 'gallery-landing-filters__group');
      group.dataset.galleryFilterKey = key;
      if (key === openGroupKey) group.open = true;
      group.addEventListener('toggle', () => {
        if (!group.open) return;
        requestAnimationFrame(fitOpenPanels);
        const sortMenu = root.querySelector('.gallery-landing-filters__sort-menu[open]');
        if (sortMenu) sortMenu.open = false;
        for (const other of root.querySelectorAll('.gallery-landing-filters__group[open]')) {
          if (other !== group) other.open = false;
        }
      });
      const selected = choices.filter((choice) => params.getAll(choice.name).includes(choice.value)).length;
      group.append(makeElement('summary', '', selected ? `${displayName} (${selected})` : displayName));
      const options = makeElement('div', 'gallery-landing-filters__options');

      for (const choice of choices) {
        const labelText = key === 'size'
          ? sizeLabels.get(choice.value) || choice.value
          : translateOption(choice.closest('label')?.querySelector('.facet-checkbox__text')?.textContent.trim() || choice.value);
        const label = makeElement('label', 'gallery-landing-filters__option');
        const input = makeElement('input');
        input.type = 'checkbox';
        input.name = choice.name;
        input.value = choice.value;
        input.checked = params.getAll(choice.name).includes(choice.value);
        input.disabled = choice.disabled;
        input.addEventListener('change', () => {
          const next = new URLSearchParams(params);
          next.delete(input.name);
          for (const checked of root.querySelectorAll('input[type="checkbox"]:checked')) {
            if (checked.name === input.name) next.append(checked.name, checked.value);
          }
          choose(next, true);
        });
        label.append(input, makeElement('span', '', labelText));
        options.append(label);
      }
      group.append(options);
      bar.append(group);
    }

    const sourceSort = source.querySelector('select[name="sort_by"]');
    if (sourceSort) {
      const wrapper = makeElement('div', 'gallery-landing-filters__sort');
      const label = makeElement('span', 'gallery-landing-filters__sort-label', t.sort);
      const menu = makeElement('details', 'gallery-landing-filters__sort-menu');
      const selectedSort = params.get('sort_by') || sourceSort.value;
      menu.dataset.gallerySortValue = sortLabels.has(selectedSort) ? selectedSort : 'created-descending';
      menu.addEventListener('toggle', () => {
        if (!menu.open) return;
        for (const group of root.querySelectorAll('.gallery-landing-filters__group[open]')) group.open = false;
      });
      const summary = makeElement('summary', '', sortLabels.get(menu.dataset.gallerySortValue));
      summary.setAttribute('aria-label', `${t.sort} ${sortLabels.get(menu.dataset.gallerySortValue)}`);
      menu.append(summary);
      const options = makeElement('div', 'gallery-landing-filters__sort-options');
      for (const sourceOption of sourceSort.options) {
        const shortLabel = sortLabels.get(sourceOption.value);
        if (!shortLabel) continue;
        const option = makeElement('button', '', shortLabel);
        option.type = 'button';
        if (sourceOption.value === menu.dataset.gallerySortValue) option.setAttribute('aria-current', 'true');
        option.addEventListener('click', () => {
          const next = new URLSearchParams(params);
          next.set('sort_by', sourceOption.value);
          menu.open = false;
          choose(next, true);
        });
        options.append(option);
      }
      menu.append(options);
      wrapper.append(label, menu);
      bar.append(wrapper);
    }

    if ([...params.keys()].some((key) => key.startsWith('filter.'))) {
      const reset = makeElement('button', 'gallery-landing-filters__reset', t.clear);
      reset.type = 'button';
      reset.addEventListener('click', () => {
        const next = new URLSearchParams();
        if (params.has('sort_by')) next.set('sort_by', params.get('sort_by'));
        choose(next, true);
      });
      bar.append(reset);
    }

    const count = makeElement('p', 'gallery-landing-filters__count', source.querySelector('#ProductCountDesktop')?.textContent.trim());
    count.setAttribute('role', 'status');
    root.replaceChildren(bar, count);
    requestAnimationFrame(fitOpenPanels);
  };

  window.addEventListener('resize', fitOpenPanels);
  window.addEventListener('scroll', fitOpenPanels, { passive: true });

  async function load(params, updateGrid, changeHistory) {
    pending?.abort();
    const controller = new AbortController();
    pending = controller;
    root.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(makeSourceUrl(params), { credentials: 'same-origin', signal: controller.signal });
      if (!response.ok) throw new Error('Filters unavailable');
      const html = await response.text();
      const page = new DOMParser().parseFromString(html, 'text/html');
      const sourceFilters = page.querySelector('#main-collection-filters');
      const sourceGrid = page.querySelector('#ProductGridContainer');
      if (!sourceFilters || !sourceGrid) throw new Error('Collection data unavailable');

      renderControls(sourceFilters, params);
      if (updateGrid) useSourceGrid(sourceGrid);
      if (changeHistory) {
        const url = new URL(window.location.href);
        for (const key of [...url.searchParams.keys()]) {
          if (allowedKey(key) || key === 'gallery_view') url.searchParams.delete(key);
        }
        for (const [key, value] of params) url.searchParams.append(key, value);
        window.history.pushState({}, '', url);
      }
    } catch (error) {
      if (error.name === 'AbortError') return;
      console.error('Gallery filters could not load', error);
      const retry = makeElement('button', 'gallery-landing-filters__reset', t.retry);
      retry.type = 'button';
      retry.addEventListener('click', () => load(params, updateGrid, changeHistory));
      root.replaceChildren(retry);
    } finally {
      if (pending === controller) root.removeAttribute('aria-busy');
    }
  }

  grid.addEventListener('click', (event) => {
    const link = event.target.closest('.pagination a[href]');
    if (!link) return;
    const url = new URL(link.href, window.location.origin);
    if (!url.searchParams.has('page')) return;
    event.preventDefault();
    const params = currentParams();
    params.set('page', url.searchParams.get('page'));
    load(params, true, true);
    root.scrollIntoView({ block: 'start', behavior: 'smooth' });
  });

  document.addEventListener('pointerdown', (event) => {
    if (event.target.closest('.gallery-landing-filters__group[open], .gallery-landing-filters__sort-menu[open]')) return;
    for (const group of root.querySelectorAll('.gallery-landing-filters__group[open]')) group.open = false;
    for (const menu of root.querySelectorAll('.gallery-landing-filters__sort-menu[open]')) menu.open = false;
  });
  root.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const group = root.querySelector('.gallery-landing-filters__group[open], .gallery-landing-filters__sort-menu[open]');
    if (group) {
      group.open = false;
      group.querySelector('summary')?.focus();
      return;
    }
  });

  for (const shortcut of shortcuts) {
    shortcut.addEventListener('click', (event) => {
      event.preventDefault();
      loadView(shortcut.dataset.galleryView, true);
    });
  }
  window.addEventListener('popstate', () => {
    const view = viewFromUrl();
    if (view === 'all') {
      showView('all');
      load(currentParams(), true, false);
    } else loadView(view, false);
  });
  const initialView = viewFromUrl();
  if (initialView === 'all') {
    showView('all');
    const initial = currentParams();
    load(initial, [...initial.keys()].length > 0, false);
  } else loadView(initialView, false);
})();
